import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'

export default {
  name: 'cuponesEC',
  mixins: [mixx],
  data() {
    return {
      msg: '-',
      loading: false,
      loading_f: false,
      tbv: null,
      tbv2: null,
      ventas: [],
      comercios_f: [],
      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
        estado: false
      }
    }
  },
  computed: {
    reporte: function () {
      return '/reportes/cupones/extracash?dsis=' + window.sssdi + '&desde=' + this.f_c.desde + '&hasta=' + this.f_c.hasta + '&estado=' + this.f_c.estado
    }
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  unmounted() {
    this.tbv.destroy();
  },
  mounted() {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    

    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      'rowCallback': function (row, data, index) { },
    });
    $('.box').boxWidget();
  },

  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post('/reportes/cupones/extracash', this.f_c)
        .then(response => {
          this.ventast_tabla = 0;
          if (response.data.status == 1) {
            for (let i = 0; i < response.data.data.length; i++) {
              response.data.data[i][13] = this.num_to_many(response.data.data[i][13]);
              this.tbv.row.add(response.data.data[i]);
            }
          }
          this.tbv.draw();
          this.loading = false;
        });
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/cuponesEC/index.js